export var selectIsShowFoldersList = function selectIsShowFoldersList(state) {
  return state.favoritesAssignWidget.showFoldersList;
};